<template>
	<AppLayout>
		<router-view></router-view>
	</AppLayout>

	<NotificationPopup />
	<GlobalLoader />
	<ScrollTopBtn />
</template>

<script setup>
import AppLayout from '@/layouts/App.vue';
import NotificationPopup from '@/components/Popup/GlobalNotification.vue';
import GlobalLoader from '@/components/GlobalLoader.vue';
import ScrollTopBtn from '@/components/ScrollTopBtn.vue';
import { watch, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { useAutoLoadStore } from '@/stores/autoLoad';

const route = useRoute();
const autoLoadStore = useAutoLoadStore();

watch(
	() => route.name,
	(newRouteName) => {
		autoLoadStore.clearListOnRoute(newRouteName);
	}
);

// FIXME
// onBeforeMount(() => {
// 	autoLoadStore.started();
// });
</script>
<style lang="scss">
.v-field {
	font-size: 0.85rem !important;
	.v-field__overlay {
		border-width: 2px !important;
		border-radius: 5px !important;
		background: #fafbfc !important;
		border-color: #f5f6f7 !important;
	}
}
</style>
